export default {
    strings: {
        pluginNameAudio: 'Audio',
        // Used as the label for the button that starts an audio recording.
        // This is not visibly rendered but is picked up by screen readers.
        startAudioRecording: 'Begin audio recording',
        // Used as the label for the button that stops an audio recording.
        // This is not visibly rendered but is picked up by screen readers.
        stopAudioRecording: 'Stop audio recording',
        // Title on the “allow access” screen
        allowAudioAccessTitle: 'Please allow access to your microphone',
        // Description on the “allow access” screen
        allowAudioAccessDescription: 'In order to record audio, please allow microphone access for this site.',
        // Title on the “device not available” screen
        noAudioTitle: 'Microphone Not Available',
        // Description on the “device not available” screen
        noAudioDescription: 'In order to record audio, please connect a microphone or another audio input device',
        // Message about file size will be shown in an Informer bubble
        recordingStoppedMaxSize: 'Recording stopped because the file size is about to exceed the limit',
        // Used as the label for the counter that shows recording length (`1:25`).
        // This is not visibly rendered but is picked up by screen readers.
        recordingLength: 'Recording length %{recording_length}',
        // Used as the label for the submit checkmark button.
        // This is not visibly rendered but is picked up by screen readers.
        submitRecordedFile: 'Submit recorded file',
        // Used as the label for the discard cross button.
        // This is not visibly rendered but is picked up by screen readers.
        discardRecordedFile: 'Discard recorded file',
    },
};
